import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';
import { resolve } from '../../../../../../init/store';

export class Controller {

    /** @ngInject */
    constructor(Alert, SharedFoldersResource) {
        this.Alert = Alert;
        this.SharedFoldersResource = SharedFoldersResource;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    save() {
        this.isSaving = true;
        this.SharedFoldersResource
            .addCorporateServiceAccounts(resolve.companyId, this.resolve.sharedFolder.id, this.st.selectedIds)
            .then(data => {
                this.close();
                this.Alert('success', 'global.messages.operation-successful');
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-csa/shared-folder-add-csa.controller.js